<template>
  <div class="schedule container">
    <h1>Schedule of Events</h1>
    <h3>(All times Eastern)</h3>
    <div class="row">
      <div class="schedule-col" v-for="(day, dayNum) in presentations" :key="(day, dayNum)">
        <div class="schedule-col-contents">
          <h2 class="schedule-col-header">Day {{ dayNum + 1 }}</h2>
          <div v-for="presentation in day" :key="presentation.title" class="schedule-col-section">
            <h3 class="presentation-speaker">{{ speakerNames(presentation.speakers) }}</h3>
            <p class="presentation-time">{{ presentation.start_time }} - {{ presentation.end_time }}</p>
            <p class="presentation-link">
              <router-link :to="presentationLink(presentation, dayNum + 1)">
                <span v-html="presentation.title"></span>
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from '../db';
import auth from '../auth';
import helpers from '../helpers';

export default {
  name: 'Schedule',
  firebase: helpers.getFirebaseObject(db),
  beforeMount() {
    auth.requireLogin();
  },
  computed: {
    presentations() {
      // console.log(helpers.getPresentationsByDay(this.speakers))
      return helpers.getPresentationsByDay(this.speakers, this.options);
    },
  },
  methods: {
    speakerNames(speakers) {
      let rtn = '';

      speakers.forEach((speaker, i) => {
        if (speakers.length > 1 && i === speakers.length - 1) {
          rtn += 'and ';
        }
        rtn += speaker;
        if (i !== speakers.length - 1) {
          rtn += ', ';
        }
      });
      return rtn;
    },
    presentationLink(presentation, dayNum) {
      let hashCode = helpers.getPresentationHash(presentation);
      return '/archive/'+dayNum+'/'+hashCode;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  display: inline-block;
}
h3 {
  display: inline-block;
}
.schedule-col {
  width: 50%;
  float: left;
  position: relative;
  min-height: 1px;
  padding-left: 15px;
  padding-right: 15px;
}

@media (max-width: 870px) {
  .schedule-col { width: 50%; }
}
@media (max-width: 500px) {
  .schedule-col { width: 100%; }
}
</style>



// WEBPACK FOOTER //
// src/components/Schedule.vue